module.exports = __webpack_public_path__ + "img/gewalt.73b0f9c6.jpg";